/** Format saved instants in the event zone, never the browser zone. */
export function reminderTime(instant: string | null, zone?: string): string {
  if (!instant) return 'Not Scheduled';
  try {
    const date = new Date(instant);
    const timeZone = zone || 'UTC';
    return `${new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'longOffset' }).format(date)} (${timeZone})`;
  } catch { return 'Invalid Scheduled Time'; }
}

/** Match the server resolver: no silent DST overlap/gap interpretation. */
export function reminderLocalPreview(local: string, zone: string): string {
  if (!local) return `Choose a time in ${zone || 'the event timezone'}.`;
  try {
    const formatter = new Intl.DateTimeFormat('sv-SE', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    const approximate = Date.parse(`${local}:00Z`);
    const matches: number[] = [];
    for (let offset = -840; offset <= 840; offset += 15) {
      const time = approximate + offset * 60000;
      if (formatter.format(time).replace(' ', 'T') === local) matches.push(time);
    }
    return matches.length === 1 ? reminderTime(new Date(matches[0]).toISOString(), zone)
      : 'This event-local time is ambiguous or does not exist. Choose another time.';
  } catch { return 'Set a valid event timezone before scheduling.'; }
}
